import React, {createRef, useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import {Grid, InputLabel} from "@material-ui/core";

import {FormDialog, Text }from "../../../../controls";
import CrewEditor from "./CrewEditor";
import Validator from "../../validators/EditCrewValidator";

import { fetch as fetchComboValues } from "../../../../services/settings/useComboValues";

const EditCrewDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const extraKeys = props.extraKeys;
  const handleUpdate = props.handleUpdateFlight
  const classes = props.classes;
  const eventBus = SystemData.eventBus;

  const dateFormat = "DD/MM/YYYY";
  const queryClient = useQueryClient();

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    title: 'Edit Crew',
    skeletonCrew: null,
    extraKeys: extraKeys
  });

  useEffect(()=> {
    const open = async (record, updateKeys) => {
      const title = `Edit Crew Details for ${record.airlineCode}${record.flightNo}`;

      const skeletonExtraKeys = ["CREW", "SKELETON"];
      const skeletonCrewData = await fetchComboValues({queryClient, extraKeys: skeletonExtraKeys});
      const skeletonCrew = {data:skeletonCrewData}

      setDialogStates(
        {
          ...dialogStates,
          showDialog:true,
          title,
          extraKeys: updateKeys||extraKeys,
          record,
          skeletonCrew
        }
      );
    }

    eventBus.bind("EditCrewDialog.open", open);

    return () => {
      eventBus.unbind("EditCrewDialog.open", open);
    }
  }, [dialogStates, eventBus, extraKeys]);

  const handleAddFunction = () => {
    if (eventBus) {
      eventBus.trigger('Crew.AddFunction');
    }
  }

  const handleCrewChanged = (changes, props) => {
    const {record, recordChange} = props;
    if (changes && changes.record) {
      const crew =  changes.record.crew;
      record['crew'] = crew;
      recordChange({...record, crew});

      if (changes.resolve) {
        changes.resolve();
      }
    }
  }


  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message=""
        open={dialogStates.showDialog}
        record={dialogStates.record}
        dialogOptions={{width: 700, maxWidth: 700}}
        classes={classes}
        validator={Validator}
        buttons = {{
          addFunction: {icon: "add_circle", key: "Add Function", label: "Add Function", color: "primary"},
          save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            handleUpdate.mutate({
              extraKeys: dialogStates.extraKeys,
              record,
              postSuccess: () => {
                setDialogStates({...dialogStates, showDialog: false, record: null});
                if (props.afterSave) {
                  props.afterSave();
                }
                if (typeof props.onClose === 'function') {props.onClose()}
              },
              postError: (data) => {
                if (props.onError) {
                  props.onError(data);
                } else if (data.errorMessage) {
                  SystemData.alert("Error", `${data.errorMessage}`);
                } else {
                  SystemData.alert("Error", `An Unexpected Error has occurred.`);
                }
              }
            });
          } else if (state.buttonPressed === "addFunction") {
            handleAddFunction();
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Flight Number
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.airlineCode}-${record.flightNo}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Flight Date
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${moment(record.flightDate, "YYYY-MM-DD HH:mm:ss").format(dateFormat)}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Trip Number
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.tripPrefix}${record.tripNo}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={6} checkChildren={true}>
            {(record, changeRecord) => (
              <div className="d-flex flex-row justify-content-between align-items-center">
                <InputLabel shrink>
                  Route
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.originAirportCode} -> ${record.destinationAirportCode}`}
                />
              </div>
            )}
          </Grid>
        </Grid>

        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={12} checkChildren={true}>
            {(record, changeRecord) => (
              <CrewEditor
                flightRecord={record}
                skeletonCrew={dialogStates.skeletonCrew}
                handleUpdate={handleUpdate}
                extraKeys={extraKeys}
                canEdit={true}
                classes={classes}
                onChange={handleCrewChanged}
              />
            )}
            </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default EditCrewDialog;
